import { parseFieldKey } from '../../fields/utils/parseFieldKey';
import { stringifyFieldIdPath } from '../../fields/utils/stringifyFieldIdPath';
import { FormSliceState } from '../types';
import { isArrayItemId } from './arrayItemId';

export function getFieldPathById(
    fieldsStateGetter: () => FormSliceState['forms'][string]['fieldsState'],
    fieldId: string
) {
    const fieldIdPath = parseFieldKey(fieldId);

    const currentIdPath: string[] = [];
    const fieldPath: string[] = [];

    for (const key of fieldIdPath) {
        if (!isArrayItemId(key)) {
            fieldPath.push(key);
            currentIdPath.push(key);
            continue;
        }

        const fieldsState = fieldsStateGetter();
        const fieldState = fieldsState[stringifyFieldIdPath(currentIdPath)];
        // Убеждаемся что это массив по наличию order
        if (fieldState && 'order' in fieldState) {
            const index = fieldState.order.indexOf(stringifyFieldIdPath([...currentIdPath, key]));

            fieldPath.push(index.toString());
        }

        currentIdPath.push(key);
    }

    return fieldPath;
}
